export default __webpack_public_path__ + "static/media/madame_detail5.fc1b211c.jpg";